var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNavSpot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1845_42756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 9.99967H8.66667C9.02029 9.99967 9.35943 9.8592 9.60948 9.60915C9.85952 9.3591 10 9.01996 10 8.66634C10 8.31272 9.85952 7.97358 9.60948 7.72353C9.35943 7.47348 9.02029 7.33301 8.66667 7.33301H6.66667C6.26667 7.33301 5.93333 7.46634 5.73333 7.73301L2 11.333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 14.0002L5.73268 13.0668C5.93268 12.8002 6.26602 12.6668 6.66602 12.6668H9.33268C10.066 12.6668 10.7327 12.4002 11.1993 11.8668L14.266 8.93351C14.5233 8.6904 14.6734 8.35505 14.6834 8.00123C14.6934 7.64741 14.5625 7.30411 14.3193 7.04685C14.0762 6.78959 13.7409 6.63944 13.3871 6.62944C13.0332 6.61944 12.6899 6.7504 12.4327 6.99351L9.63268 9.59351",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 10.667L5.33398 14.667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6658 7.93307C11.7335 7.93307 12.5991 7.06749 12.5991 5.99974C12.5991 4.93199 11.7335 4.06641 10.6658 4.06641C9.598 4.06641 8.73242 4.93199 8.73242 5.99974C8.73242 7.06749 9.598 7.93307 10.6658 7.93307Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5.33301C5.10457 5.33301 6 4.43758 6 3.33301C6 2.22844 5.10457 1.33301 4 1.33301C2.89543 1.33301 2 2.22844 2 3.33301C2 4.43758 2.89543 5.33301 4 5.33301Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1845_42756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavSpot);
export default __webpack_public_path__ + "static/media/icon-nav-spot.36e2f9cb6cf2e0619d8b7a2fc210617d.svg";
export { ForwardRef as ReactComponent };